import React, { useState } from "react";
import { Card, Button, Tooltip, Modal, Space, Typography, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import IndexBrowse from "./browse/index.js";
import ModalNewDocs from "./ModalNewDocs";
import ModalUploadFile from "./modalUpload";
import TrackingModal from "./TrackingModal";
import axiosInstance from "../../configs";

const { Title } = Typography;

const DocPabean = () => {
  const [openTambah, setOpenTambah] = useState(false);
  const [openUpload, setOpenUpload] = useState(false);
  const [openTracking, setOpenTracking] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const handleUploadSubmit = (data) => {
    message.success("File berhasil diunggah!");
    console.log("NPWP:", data.npwp);
    console.log("File:", data.file);
  };

  const handleDownloadTemplate = async () => {
    setDownloadLoading(true);
    try {
      const response = await axiosInstance.get(
        "/portal/pasifik/download-template",
        {
          responseType: "blob",
        },
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "FORM_TEMPLATE.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      message.success("Template berhasil didownload!");
    } catch (error) {
      console.error("Download template error:", error);
      message.error("Gagal mendownload template.");
    } finally {
      setDownloadLoading(false);
    }
  };

  return (
    <div>
      {/* ====== Card Section ====== */}
      <div
        className="kt-container kt-container--fluid"
        style={{ marginTop: 20 }}
      >
        <Card
          bordered={false}
          className="shadow-sm"
          style={{
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          }}
          // Use flex column for Title/Actions on small screens, row on large
          headStyle={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            minHeight: "auto",
            padding: "12px 24px",
          }}
          bodyStyle={{ padding: "12px", overflowX: "auto" }} // Allow horizontal scroll for table
          title={
            <div style={{ padding: "4px 0" }}>
              <Title level={4} style={{ margin: 0 }}>
                Dokumen Pabean Ceisa 4.0
              </Title>
            </div>
          }
          extra={
            <div style={{ marginTop: 5, marginBottom: 5 }}>
              <Space wrap size={[8, 8]}>
                <Tooltip title="Dokumen Baru">
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "#28a745",
                      borderColor: "#28a745",
                    }}
                    onClick={() => setOpenTambah(true)}
                  >
                    <i
                      className="flaticon2-plus kt-menu__link-icon"
                      style={{ marginRight: 6 }}
                    />
                    Dokumen Baru
                  </Button>
                </Tooltip>

                {/* <Tooltip title="Download Template Excel">
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "#17a2b8",
                      borderColor: "#17a2b8",
                    }}
                    onClick={handleDownloadTemplate}
                    loading={downloadLoading}
                    icon={<DownloadOutlined />}
                  >
                    Download Template
                  </Button>
                </Tooltip> */}

                <Tooltip title="Upload File Excel">
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "#007bff",
                      borderColor: "#007bff",
                    }}
                    onClick={() => setOpenUpload(true)}
                  >
                    <i
                      className="flaticon-upload kt-menu__link-icon"
                      style={{ marginRight: 6 }}
                    />
                    Upload
                  </Button>
                </Tooltip>

                <Tooltip title="Tracking Data">
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "#fd7e14",
                      borderColor: "#fd7e14",
                    }}
                    onClick={() => setOpenTracking(true)}
                  >
                    <i
                      className="flaticon2-search-1 kt-menu__link-icon"
                      style={{ marginRight: 6 }}
                    />
                    Tracking
                  </Button>
                </Tooltip>

                <Tooltip title="Muat Ulang">
                  <Button
                    type="default"
                    onClick={() => window.location.reload()}
                  >
                    <i
                      className="flaticon-refresh kt-menu__link-icon"
                      style={{ marginRight: 6 }}
                    />
                    Muat Ulang
                  </Button>
                </Tooltip>
              </Space>
            </div>
          }
        >
          {/* <Divider /> */}
          <div style={{ overflowX: "auto" }}>
            <IndexBrowse />
          </div>
        </Card>
      </div>

      {/* ====== Modal Tambah Data ====== */}
      <ModalNewDocs open={openTambah} onClose={() => setOpenTambah(false)} />

      {/* ====== Modal Upload File ====== */}
      <Modal
        title={
          <div
            style={{
              background: "#f5f9fc", // putih keabu-abuan / ivory soft
              margin: "-24px -24px 16px -24px",
              padding: "16px 24px",
              borderBottom: "1px solid #e9ecef",
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
            }}
          >
            <span
              style={{
                fontSize: "18px",
                fontWeight: 600,
                color: "#2c3e50",
              }}
            >
              Upload Excel Dokumen Pabean
            </span>
          </div>
        }
        open={openUpload}
        onCancel={() => setOpenUpload(false)}
        footer={null}
        width={700}
        centered
        bodyStyle={{
          paddingTop: 0,
        }}
      >
        <ModalUploadFile
          onClose={() => setOpenUpload(false)}
          onSubmit={handleUploadSubmit}
        />
      </Modal>

      {/* ====== Modal Tracking ====== */}
      <TrackingModal
        open={openTracking}
        onClose={() => setOpenTracking(false)}
      />
    </div>
  );
};

export default DocPabean;
